<template>
    <div class="navigation-locations">
        <div class="navigation__loader" v-if="loading || error">
            <LoadingIndicator />
        </div>
        <div class="navigation-locations" v-if="!loading && !error">
            <div class="navigation-locations__filters">
                <div class="navigation-locations__filters-title">Filter by</div>
                <button class="navigation-locations__filter-button" :class="{
                    'navigation-locations__filter-button--active':
                        activeRegion === region,
                }" v-for="region in regions" :key="region" @click="toggleRegion(region)">
                    {{ region }}
                </button>
            </div>
            <div class="navigation-locations__results" v-if="activeLocations && activeLocations.length > 0">
                <div class="navigation-locations__link-wrapper" v-for="(slice, index) in slicedLocations" :key="index">
                    <template v-for="(location, i) in slice" :key="i">
                        <a class="navigation-locations__link" :href="location.url">{{
                            location.title
                        }}
                            <span class="locations-card__translations" style="margin-left: 8px"
                                v-if="location.hasCulture">{{
                                    location.translationsAvailableLabel }}
                            </span>
                        </a>
                    </template>
                </div>
            </div>
        </div>
        <div class="navigation-locations__mobile-action">
            <a href="/locations" class="button">View all locations</a>
        </div>
    </div>
</template>

<script>
import LocationService from "../../services/locations";
import LoadingIndicator from "../../components/Global/LoadingIndicator.vue";

export default {
    components: {
        LoadingIndicator,
    },
    data() {
        return {
            error: false,
            loading: true,
            locations: [],
            regions: [],
            activeRegion: null,
            activeLocations: [],
        };
    },
    mounted() {
        this.getLocations();
    },
    computed: {
        slicedLocations() {
            const res = [];
            let chunkSize = 6;
            let locations = this.activeLocations.sort((a, b) =>
                a.title > b.title ? 1 : b.title > a.title ? -1 : 0
            );
            for (let i = 0; i < locations.length; i += chunkSize) {
                const chunk = locations.slice(i, i + chunkSize);
                res.push(chunk);
            }
            return res;
        },
    },
    watch: {
        locations: function () {
            let regions = [];
            this.locations.forEach((location) => {
                if (!regions.includes(location.region)) {
                    regions.push(location.region);
                }
            });
            this.regions = regions.sort((a, b) => b - a);

            this.activeRegion = regions[0];
            this.activeLocations = this.locations.filter((location) => {
                return location.region === this.activeRegion;
            });
        },
    },
    methods: {
        toggleRegion: function (key) {
            this.activeRegion = key;
            this.activeLocations = this.locations.filter((location) => {
                return location.region === key;
            });
        },
        getLocations: async function () {
            try {
                const locations = await LocationService.locations();
                this.locations = locations.locations;
                this.loading = false;
            } catch (error) {
                this.error = true;
                this.loading = false;
            }
        },
    },
};
</script>

